"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesFilesUpdateSyncSlice = void 0;
const get_1 = require("./get.js");
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesFilesUpdateSyncSlice = (0, xuder_1.createUpdateCollectionSyncSlice)({
    hasRequest: true,
    name: name_1.CoreInitiativesFilesName,
    state: get_1.coreInitiativesFilesGetAsyncSlice.asyncState,
    target: (request) => (file) => file.id === request.id,
    update: (request) => (file) => {
        var _a;
        return (Object.assign(Object.assign({}, file), { name: (_a = request.name) !== null && _a !== void 0 ? _a : '' }));
    }
});
//# sourceMappingURL=update.js.map